(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tric-mobile-bar"] && !Shopify.designMode) return;
  try {
    const bindTricMobileBar = () => {
    document.querySelectorAll('.tric-mobile-bar [data-js-sidebar-handle]').forEach(button => {
      if (button.dataset.tricBound) return;
      const drawer = document.getElementById(button.getAttribute('aria-controls'));
      if (!drawer) return;
      button.dataset.tricBound = 'true';
      const sync = () => button.setAttribute('aria-expanded', String(drawer.classList.contains('sidebar--opened')));
      new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindTricMobileBar, { once: true });
  else bindTricMobileBar();
  document.addEventListener('shopify:section:load', bindTricMobileBar);
  } catch(e) { console.error(e); }
})();

})();
